import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 1025;

type NavigatorWithUAData = Navigator & {
  userAgentData?: {
    platform?: string;
  };
};

export const isMobileDevice = (): boolean => {
  return window.innerWidth < MOBILE_BREAKPOINT;
};

export const isAndroidDevice = (): boolean => {
  const nav = window.navigator as NavigatorWithUAData;
  const uaDataPlatform = nav.userAgentData?.platform;
  return /Android/i.test(nav.userAgent) || uaDataPlatform === 'Android';
};

export const useIsMobile = (breakpoint = MOBILE_BREAKPOINT): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < breakpoint);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    checkIfMobile();

    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [breakpoint]);

  return isMobile;
};

export const useIsAndroid = (): boolean => {
  const [isAndroid, setIsAndroid] = useState<boolean>(false);

  useEffect(() => {
    setIsAndroid(isAndroidDevice());
  }, []);

  return isAndroid;
};

export default useIsMobile;
